import script from "./DueDiligenceRecordFields.vue?vue&type=script&setup=true&lang=js"
export * from "./DueDiligenceRecordFields.vue?vue&type=script&setup=true&lang=js"

import "./DueDiligenceRecordFields.vue?vue&type=style&index=0&id=85bae136&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-85bae136"]])

export default __exports__